import React, { useEffect, useCallback, useRef, useState } from "react";
import { Typography, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useLanguageContext } from "../../Context/LanguageContext";
import AccordionUi from "../ReusableComponent/Accordion";

import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import _ from "lodash";
export default function EquipmentGrpSideBar({
  equipmentGrpResponse,
  onItemSelected,
}) {
  const { localization } = useLanguageContext();

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const debounceFn = useCallback(_.debounce(handleDebounceFn, 1000), []);
  const [activeAccorder, setActiveAccorder] = useState(false);
  const [renderMe, setRenderMe] = useState(false);
  const [accordionData, setAccordionData] = useState(null);
  const [searchQueryRefresh, setSearchQueryRefresh] = useState(0);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const inputRef = useRef("");
  const handelOnChange = (e) => {
    debounceFn(e.target.value);
  };

  function handleDebounceFn(inputValue) {
    setSearch(search !== "" ? inputValue : inputValue.trim());
  }
  useEffect(() => {
    if (equipmentGrpResponse) {
      const { plantNameList, response } = { ...equipmentGrpResponse };
      let selectedPlant;
      let EqG_id_ini =
        sessionStorage.getItem("eqGId") !== null &&
        sessionStorage.getItem("eqGId") !== undefined
          ? sessionStorage.getItem("eqGId")
          : equipmentGrpResponse != null
            ? response[plantNameList[0]][0].id
            : 0;

      if (sessionStorage.getItem("eqGId") === null) {
        selectedPlant =
          response[plantNameList[0]][0].plantId + "-" + plantNameList[0];
        setActiveAccorder(0);
      } else {
        plantNameList.some((plant, index) => {
          const isFind = response[plant].find((eqlist) => {
            return eqlist.id === EqG_id_ini;
          });
          if (isFind) {
            selectedPlant = response[plant][0].plantId + "-" + plant;
            setActiveAccorder(index);
            return true;
          }
        });
      }

      let EqG_Bez_ini =
        sessionStorage.getItem("eqBez") !== null &&
        sessionStorage.getItem("eqBez") !== undefined
          ? sessionStorage.getItem("eqBez")
          : equipmentGrpResponse != null
            ? equipmentGrpResponse[plantNameList[0]][0].bezeichnung
            : 0;
      let EqG_copyFunc_ini =
        sessionStorage.getItem("copyFunktion") !== null &&
        sessionStorage.getItem("copyFunktion") !== undefined
          ? sessionStorage.getItem("copyFunktion")
          : 1;
      if (message !== "") {
        setMessage("");
      }

      setAccordionData({
        plantNameList: plantNameList,
        response: response,
        plantOrginal: plantNameList,
        responseOriginale: response,
      });
    } else {
      if (message === "") {
        setMessage(localization.noRecordFound);
      }
    }
  }, [equipmentGrpResponse]);

  useEffect(() => {
    if (accordionData) {
      const { plantNameList, response, plantOrginal, responseOriginale } = {
        ...accordionData,
      };
      setGlobalSpinner(true);
      if (search.length != 0) {
        var tmp = { ...responseOriginale };
        var filterlist = {};
        plantOrginal.map((item) => {
          const _itemlist = tmp[item].filter((item) =>
            item.bezeichnungsDisplay
              .toLowerCase()
              .includes(search.toLowerCase()),
          );
          if (_itemlist.length > 0) {
            filterlist[item] = _itemlist;
          }
        });
        const _tempPlantlist = plantOrginal.filter((item) =>
          Object.keys(filterlist).includes(item),
        );
        setAccordionData((prev) => ({
          ...prev,
          plantNameList: _tempPlantlist,
          response: filterlist,
        }));
        // setPlantList(_tempPlantlist);
        // setEquipmentGroupList(filterlist);
        setSearchQueryRefresh(1);
        if (_tempPlantlist.length > 0) {
          if (message !== "") {
            setMessage("");
          }
        } else if (message === "") {
          setMessage(localization.noRecordFound);
        }
      } else if (search.length === 0 && searchQueryRefresh === 1) {
        var tmp = { ...responseOriginale };
        setSearchQueryRefresh(0);
        setAccordionData((prev) => ({
          ...prev,
          plantNameList: plantOrginal,
          response: tmp,
        }));
        setMessage("");
      }
      setGlobalSpinner(false);
    } else if (accordionData && searchQueryRefresh === 1) {
      var tmp = [...accordionData.responseOriginale];
      var res = tmp.filter((item) =>
        item.bezeichnungsDisplay.toLowerCase().includes(search.toLowerCase()),
      );
      setAccordionData((prev) => ({
        ...prev,
        response: res,
      }));
      setSearchQueryRefresh(1);
    }
  }, [search]);

  useEffect(() => {
    let _render = null;

    if (accordionData && accordionData.response) {
      _render = (
        <AccordionUi
          plantList={accordionData.plantNameList}
          path={""}
          equipmentGroupList={accordionData.response}
          onClick={onItemSelected}
          setActiveAccorder={setActiveAccorder}
          activeAccorder={activeAccorder}
        />
      );
    }

    setRenderMe(_render);
  }, [accordionData]);

  return (
    accordionData && (
      <div className="sidebar-header">
        <Typography className="sideBarHeader">
          {localization.equipmentGroup}
        </Typography>
        <TextField
          className="sideBarSearchCls"
          ref={inputRef}
          placeholder={localization.search}
          variant="outlined"
          autoFocus={true}
          fullWidth
          margin="normal"
          onChange={handelOnChange}
          defaultValue={search}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon className="searchIconCls" />
              </InputAdornment>
            ),
          }}
        />
        {renderMe}
        <span>{message}</span>
      </div>
    )
  );
}
